module.exports = __webpack_public_path__ + "img/controller.light.c0ad5e19.svg";